import isEmpty from 'lodash/isEmpty';
import isString from 'lodash/isString';
import moment from 'moment';
import { getDayDifference } from './getDayDifference';

const DATE_FORMAT = 'ddd, DD MMM';

export interface GetReportReadableDateTypes {
  currentStartDate: string;
  currentEndDate: string;
}

export const getReportReadableDate = ({ currentStartDate, currentEndDate }: GetReportReadableDateTypes) => {
  if (
    isEmpty(currentStartDate) ||
    isEmpty(currentEndDate) ||
    !isString(currentStartDate) ||
    !isString(currentEndDate) ||
    !moment(currentStartDate).isValid() ||
    !moment(currentEndDate).isValid()
  )
    throw new Error('Invalid Date Format', { cause: { currentStartDate, currentEndDate } });

  // derive isWeek value from currentStartDate and currentEndDate
  const dayDifference = getDayDifference({
    startDate: currentStartDate,
    endDate: currentEndDate,
  });

  const isWeek = dayDifference <= 7;

  const currentPeriodDateRange = `${moment(currentStartDate).format(DATE_FORMAT)} - ${moment(currentEndDate)
    .subtract(1, 'day')
    .format(DATE_FORMAT)} ${moment(currentStartDate).year()}`;

  // eslint-disable-next-line no-useless-assignment
  let currentPeriod = '';

  // Show weekly dates
  if (isWeek) {
    currentPeriod = `Week ${moment(currentStartDate).startOf('week').week()}`;
  } else {
    //show monthly dates
    currentPeriod = `${moment(currentStartDate).startOf('month').format('MMMM')}`;
  }

  return {
    currentPeriod,
    currentPeriodDateRange,
  };
};
